var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDeviceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 16C11.25 13.9289 12.9289 12.25 15 12.25H29C31.0711 12.25 32.75 13.9289 32.75 16V19C32.75 21.0711 31.0711 22.75 29 22.75H15C12.9289 22.75 11.25 21.0711 11.25 19V16ZM15 13.75C13.7574 13.75 12.75 14.7574 12.75 16V19C12.75 20.2426 13.7574 21.25 15 21.25H29C30.2426 21.25 31.25 20.2426 31.25 19V16C31.25 14.7574 30.2426 13.75 29 13.75H15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 25C11.25 22.9289 12.9289 21.25 15 21.25H29C31.0711 21.25 32.75 22.9289 32.75 25V28C32.75 30.0711 31.0711 31.75 29 31.75H15C12.9289 31.75 11.25 30.0711 11.25 28V25ZM15 22.75C13.7574 22.75 12.75 23.7574 12.75 25V28C12.75 29.2426 13.7574 30.25 15 30.25H29C30.2426 30.25 31.25 29.2426 31.25 28V25C31.25 23.7574 30.2426 22.75 29 22.75H15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 16.5C28.5523 16.5 29 16.9477 29 17.5V17.51C29 18.0623 28.5523 18.51 28 18.51C27.4477 18.51 27 18.0623 27 17.51V17.5C27 16.9477 27.4477 16.5 28 16.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 25.5C28.5523 25.5 29 25.9477 29 26.5V26.51C29 27.0623 28.5523 27.51 28 27.51C27.4477 27.51 27 27.0623 27 26.51V26.5C27 25.9477 27.4477 25.5 28 25.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 17.5C15.25 17.0858 15.5858 16.75 16 16.75H24C24.4142 16.75 24.75 17.0858 24.75 17.5C24.75 17.9142 24.4142 18.25 24 18.25H16C15.5858 18.25 15.25 17.9142 15.25 17.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 26.5C15.25 26.0858 15.5858 25.75 16 25.75H24C24.4142 25.75 24.75 26.0858 24.75 26.5C24.75 26.9142 24.4142 27.25 24 27.25H16C15.5858 27.25 15.25 26.9142 15.25 26.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDeviceLight);
export default __webpack_public_path__ + "static/media/btn_device_light.a65374e7c7ac5ec8320d4c7dcb71da4f.svg";
export { ForwardRef as ReactComponent };